import { FC, useEffect } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import Button from "../Button/Button";
import {
  selectAuthErrorResetPassword,
  selectAuthLoading,
  selectAuthStatusResetPassword
} from "../../store/selectors/auth";
import { resetPasswordSchema } from "../../utils/validators";
import AuthLayout from "../../layout/AuthLayout/AuthLayout";
import { resetPasswordUser, setRecovery } from "../../store/auth/slice";
import { FormikInputFieldHide } from "../FormikField";
import { DEFAULT_AUTHENTICATED_ROUTE } from "../../constants/routes";

import styles from "./ResetPassword.module.css";



const ResetPassword: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(selectAuthLoading);
  const status = useSelector(selectAuthStatusResetPassword);
  const errorResetPassword = useSelector(selectAuthErrorResetPassword);

  useEffect(() => {
    if (status) {
      dispatch(setRecovery(false));
      navigate(DEFAULT_AUTHENTICATED_ROUTE, { replace: true });
    }
  }, [status]);

  return (
    <AuthLayout>
      <div className={styles["Reset-password"]}>
        <header className={styles["Reset-password__header"]}>
          <h1 className={styles["Reset-password__title"]}>Reset password</h1>
        </header>
        <Formik
          initialValues={{ newPassword: '', confirmPassword: '' }}
          validationSchema={resetPasswordSchema}
          onSubmit={(values) => {
            dispatch(resetPasswordUser({
              password: values.newPassword,
            }));
          }}
        >
          {() => (
            <Form className={styles.form} autoComplete="off">
              <div className={styles.form__field}>
                <FormikInputFieldHide
                  placeholder="New password"
                  name="newPassword"
                />
              </div>

              <div className={styles.form__field}>
                <FormikInputFieldHide
                  placeholder="Confirm password"
                  name="confirmPassword"
                />
              </div>

              <Button
                type="submit"
                label="Confirm"
                typeStyle="fill-dark"
                size="lg"
                className={styles.form__submit}
                disabled={loading}
              />

              {errorResetPassword && <p className={styles.form__error}>{errorResetPassword}</p>}
            </Form>
          )}
        </Formik>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
